import React from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import EtiquetteScreen from "../screens/Etiquette/containers/EtiquetteScreen";
import CreateRoomContainer from "../screens/CreateRoom/containers/CreateRoomContainer";
import CallContainer from "../screens/Call/containers/CallContainer";
import PostCallContainer from "../screens/PostCall/containers/PostCallContainer";
import EditRoomContainer from "../screens/EditRoom/containers/EditRoomContainer";
import JoinRoomConfirmScreen from "../components/RegisterForMeetingModal";
import JoinForMeetingModal from "../components/JoinForMeetingModal";
import RootStackParamList from "./RootStackParamList";
import MeetingsTabsContainer from "../screens/MeetingsList/containers/MeetingsTabsContainer";
import AppHeaderContainer from "../components/AppHeader/AppHeaderContainer";
import AppHeaderLeaveButton from "../components/AppHeader/AppHeaderLeaveButton";
import { triggerCallHeaderLeave } from "../screens/Call/callHeaderActions";
import AppHeaderMenuScreen from "../screens/AppHeaderMenuScreen";
import AdminUsersScreen from "../screens/AdminUsersScreen";
import AdminConversationsScreen from "../screens/AdminConversationsScreen";
import AdminSignupFunnelScreen from "../screens/AdminSignupFunnelScreen";
import ProfileScreen from "../screens/ProfileScreen";
import InboxScreen from "../screens/InboxScreen";
import ConversationStartersScreen from "../screens/ConversationStartersScreen";
import { useAuth } from "../context/AuthContext";
import AuthScreensContainer from "../screens/Auth/containers/AuthScreensContainer";

const Stack = createNativeStackNavigator<RootStackParamList>();

export default function RootStack() {
  const { user } = useAuth();
  const isAuthenticated = !!(user && user.displayName);

  return (
    <Stack.Navigator
      screenOptions={{
        header: () => <AppHeaderContainer />,
        headerStyle: { backgroundColor: "#F6F7F9" },
      }}
    >
      {isAuthenticated ? (
        <>
          <Stack.Screen name="MeetingsTabs" component={MeetingsTabsContainer} />
          <Stack.Screen
            name="Etiquette"
            component={EtiquetteScreen}
            options={{
              header: () => (
                <AppHeaderContainer
                  backgroundColor="#232335"
                  logoTextColor="#fff"
                />
              ),
              headerStyle: { backgroundColor: "#232335" },
            }}
          />
          <Stack.Screen name="Schedule" component={CreateRoomContainer} />
          <Stack.Screen
            name="ConversationStarters"
            component={ConversationStartersScreen}
            options={{
              header: () => (
                <AppHeaderContainer
                  backgroundColor="#232335"
                  logoTextColor="#fff"
                />
              ),
              headerStyle: { backgroundColor: "#232335" },
            }}
          />
          <Stack.Screen
            name="Call"
            component={CallContainer}
            options={{
              header: () => (
                <AppHeaderContainer
                  backgroundColor="#232335"
                  logoTextColor="#fff"
                  rightComponent={
                    <AppHeaderLeaveButton onPress={triggerCallHeaderLeave} />
                  }
                />
              ),
              headerStyle: { backgroundColor: "#232335" },
            }}
          />
          <Stack.Screen name="EditMeeting" component={EditRoomContainer} />
          <Stack.Screen
            name="PostCall"
            component={PostCallContainer}
            options={{
              header: () => (
                <AppHeaderContainer
                  backgroundColor="#232335"
                  logoTextColor="#fff"
                />
              ),
              headerStyle: { backgroundColor: "#232335" },
            }}
          />
          <Stack.Screen
            name="HeaderMenu"
            component={AppHeaderMenuScreen}
            options={{ headerShown: false }}
          />
          <Stack.Screen name="AdminUsers" component={AdminUsersScreen} />
          <Stack.Screen
            name="AdminConversations"
            component={AdminConversationsScreen}
          />
          <Stack.Screen
            name="AdminSignupFunnel"
            component={AdminSignupFunnelScreen}
          />
          <Stack.Screen name="Profile" component={ProfileScreen} />
          <Stack.Screen name="Inbox" component={InboxScreen} />
          <Stack.Screen
            name="JoinConfirm"
            component={JoinRoomConfirmScreen}
            options={{
              presentation: "transparentModal",
              animation: "fade",
              contentStyle: { backgroundColor: "transparent" },
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="MeetingJoin"
            component={JoinForMeetingModal}
            options={{
              presentation: "transparentModal",
              animation: "fade",
              contentStyle: { backgroundColor: "transparent" },
              headerShown: false,
            }}
          />
        </>
      ) : (
        <Stack.Screen
          name="Auth"
          component={AuthScreensContainer}
          options={{ headerShown: false }}
        />
      )}
    </Stack.Navigator>
  );
}
